export default {
  pageTitle: 'Knowledge Base',
  heroDesc: 'Cross-border Business and Legal Knowledge Hub',
  allCategories: 'All',
  companyRegistration: 'Company Registration',
  taxPlanning: 'Tax Planning',
  legalCompliance: 'Legal Compliance',
  crossBorderInvestment: 'Cross-border Investment',
  financialManagement: 'Financial Management',
  other: 'Other',
  searchPlaceholder: 'Search articles...',
  featuredArticle: 'Featured Article',
  readMore: 'Read More',
  readFullArticle: 'Read Full Article',
  loadMore: 'Load More Articles',
  minutesRead: 'min read',
  categoryCompanyReg: 'Company Registration',
  categoryTaxPlanning: 'Tax Planning',
  categoryBankAccount: 'Bank Account',
  categoryLegal: 'Legal & Compliance',
  categoryCaseStudy: 'Case Study',
  categoryIndustryNews: 'Industry News',
  categoryVIE: 'VIE Structure',
  article1Title: '2024 Hong Kong Company Registration Guide',
  article1Excerpt: 'Detailed introduction to Hong Kong company registration process, required materials, precautions and latest policy changes...',
  article1ReadTime: '8 min read',
  article2Title: 'How to Leverage Hong Kong\'s Low Tax Policy',
  article2Excerpt: 'In-depth analysis of Hong Kong\'s tax system, teaching you how to optimize corporate tax structure under legal compliance...',
  article2ReadTime: '10 min read',
  article3Title: 'Hong Kong Bank Account Opening: Process & Tips',
  article3Excerpt: 'Comparison of account opening requirements for major Hong Kong banks, detailed process, common problems and solutions...',
  article3ReadTime: '7 min read',
  article4Title: 'VIE Structure Explained: Setup and Compliance',
  article4Excerpt: 'Comprehensive analysis of VIE structure concepts, setup process, legal risks and compliance precautions...',
  article4ReadTime: '12 min read',
  article5Title: 'How Cross-border E-commerce Companies Reduce Costs Through Offshore Companies',
  article5Excerpt: 'Real case study: How a cross-border e-commerce company saved millions in taxes through proper offshore structures...',
  article5ReadTime: '9 min read',
  article6Title: '2024 ODI Overseas Investment Policy Interpretation',
  article6Excerpt: 'Analysis of latest ODI policy changes and how companies should respond to new regulatory requirements...',
  article6ReadTime: '6 min read',
}
